var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustryPharma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-1024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-details",
    transform: "translate(-569.000000, -131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/industry-pharma",
    transform: "translate(569.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#07575B",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "pharmacy-(1)",
    transform: "translate(3.000000, 3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9497656,2.05023438 C10.6276133,0.728136719 8.86976562,0 7,0 C5.13023438,0 3.37238672,0.728136719 2.05023438,2.05023438 C0.728136719,3.37238672 0,5.13023438 0,7 C0,8.86976562 0.728136719,10.6276133 2.05023438,11.9497656 C3.37238672,13.2718633 5.13023438,14 7,14 C8.86976562,14 10.6276133,13.2718633 11.9497656,11.9497656 C13.2718633,10.6276133 14,8.86976562 14,7 C14,5.13023438 13.2718633,3.37238672 11.9497656,2.05023438 Z M11.2426372,11.2426372 C10.1093805,12.3758938 8.60266372,13 7,13 C5.39733628,13 3.89061947,12.3758938 2.75736283,11.2426372 C1.62410619,10.1093805 1,8.60266372 1,7 C1,5.39733628 1.62410619,3.89061947 2.75736283,2.75736283 C3.89061947,1.62410619 5.39733628,1 7,1 C8.60266372,1 10.1093805,1.62410619 11.2426372,2.75736283 C12.3758938,3.89061947 13,5.39733628 13,7 C13,8.60266372 12.3758938,10.1093805 11.2426372,11.2426372 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2,7.95754731 L7.95754731,7.95754731 L7.95754731,7.95754731 L7.95754731,10.2 C7.95754731,10.3656854 7.82323273,10.5 7.65754731,10.5 L6.34245269,10.5 C6.17676727,10.5 6.04245269,10.3656854 6.04245269,10.2 L6.04245269,7.95754731 L6.04245269,7.95754731 L3.8,7.95754731 C3.63431458,7.95754731 3.5,7.82323273 3.5,7.65754731 L3.5,6.34245269 C3.5,6.17676727 3.63431458,6.04245269 3.8,6.04245269 L6.04245269,6.04245269 L6.04245269,6.04245269 L6.04245269,3.8 C6.04245269,3.63431458 6.17676727,3.5 6.34245269,3.5 L7.65754731,3.5 C7.82323273,3.5 7.95754731,3.63431458 7.95754731,3.8 L7.95754731,6.04245269 L7.95754731,6.04245269 L10.2,6.04245269 C10.3656854,6.04245269 10.5,6.17676727 10.5,6.34245269 L10.5,7.65754731 C10.5,7.82323273 10.3656854,7.95754731 10.2,7.95754731 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryPharma);
export default __webpack_public_path__ + "static/media/industry-pharma.b9884148.svg";
export { ForwardRef as ReactComponent };